/** Standard ITU-T G.711 mu-law decode (the widely-used reference
 * "ulaw2linear" algorithm). Twilio Media Streams send 8-bit mu-law audio
 * at 8kHz mono; this converts each byte to a 16-bit linear PCM sample so it
 * can be played back through the Web Audio API. Pure and dependency-free so
 * it can be unit-tested without a browser or an AudioContext. */
export function mulawByteToLinear16(rawByte) {
  const u = (~rawByte) & 0xff;
  const sign = u & 0x80;
  const exponent = (u & 0x70) >> 4;
  const mantissa = u & 0x0f;
  let t = (mantissa << 3) + 0x84;
  t = t << exponent;
  return sign ? 0x84 - t : t - 0x84;
}

function base64ToBytes(base64) {
  if (typeof atob === "function") {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return bytes;
  }
  return new Uint8Array(Buffer.from(base64, "base64"));
}

/** Decodes a base64-encoded mu-law frame into Float32 samples in [-1, 1],
 * the format Web Audio's AudioBuffer expects. */
export function decodeMulawBase64(base64) {
  const bytes = base64ToBytes(base64);
  const out = new Float32Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) {
    out[i] = mulawByteToLinear16(bytes[i]) / 32768;
  }
  return out;
}
